import { Formik } from 'formik'

import { ICreateStylesForm } from 'src/types'
import { stylesCreateSchema } from 'src/common/validations'

import { StyleCreateForm } from './form'
import { useAccountStyles, useCreateAccountStyles } from 'src/hooks'

interface IProps {
  handleClose: () => void
  accountId: string
}

export const ModalInner = ({ handleClose, accountId }: IProps) => {
  const { mutateAsync } = useCreateAccountStyles({ accountId })
  const { data: styles, isFetching: stylesLoading } = useAccountStyles(accountId)

  const handleSubmit = async (values: ICreateStylesForm) => {
    await mutateAsync(values)
    handleClose()
  }

  if (stylesLoading) return null

  return (
    <Formik
      onSubmit={handleSubmit}
      validationSchema={stylesCreateSchema}
      initialValues={{ file: null, custom_css: styles?.custom_css || null }}
    >
      <StyleCreateForm />
    </Formik>
  )
}
